import React from 'react';
import PriceCategoryRow from './PriceCategoryRow';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  priceCategories: Julius.Website.PriceCategoryViewModel[];
}

class PriceCategoriesList extends React.PureComponent<IProps> {
  render() {
    const { priceCategories } = this.props;
    return (
      <div className='price-categories-list'>
        { priceCategories.map((pc: Julius.Website.PriceCategoryViewModel) => (
          <PriceCategoryRow
            key={ `pricecategory:${ pc.id }` }
            availableSeats={ pc.availableSeats }
            name={ pc.name }
            discription={ pc.description }
            price={ pc.price }
            color={ pc.color }
          />
        )) }
        <FormattedText 
          style='price-category-row disabled' 
          displayName='Inte tillgänglig plats'
          formattedName='order.seatpicker.notavailable'
        />
      </div>
    );
  }
}

export default PriceCategoriesList;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/PriceCategoriesList/PriceCategoriesList.tsx